/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {Injectable} from '@angular/core';
export class ExpandableRowsCount {
private expandableCount = 0;
/**
 * @return {?}
 */
public register() {
        this.expandableCount++;
    }
/**
 * @return {?}
 */
public unregister() {
        this.expandableCount--;
    }
/**
 * false means no rows with action
 * @return {?}
 */
public get hasExpandableRow(): boolean {
        return this.expandableCount > 0;
    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ExpandableRowsCount_tsickle_Closure_declarations() {
/** @type {?} */
ExpandableRowsCount.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ExpandableRowsCount.ctorParameters;
/** @type {?} */
ExpandableRowsCount.prototype.expandableCount;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
